import Api from ".."; // Seguindo exatamente o padrão do seu projeto!

const NotificacaoService = {
    enviarNotificacao: async (dados) => {
        try {
            // Note que usamos Api (com A maiúsculo)
            const response = await Api.post('/notificacoes/enviar', dados);
            return response.data;
        } catch (error) {
            console.error("Erro ao enviar notificação", error);
            throw error;
        }
    },

    getHistorico: async () => {
        try {
            // Note que usamos Api (com A maiúsculo)
            const response = await Api.get('/notificacoes/historico');
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar histórico", error);
            throw error;
        }
    },

    // ===== Automação de designações pendentes (tela "Comunicações Especiais" - admin) =====

    // Dispara agora o lembrete para todo publicador com designação pendente de hoje em diante
    dispararDesignacoesPendentes: async () => {
        try {
            const response = await Api.post('/notificacoes/designacoes-pendentes/disparar');
            return response.data; // { mensagem, resultado }
        } catch (error) {
            console.error("Erro ao disparar designações pendentes", error);
            throw error;
        }
    },

    // Teste: dispara AGORA os avisos de designação pendente de UM publicador (admin).
    // Ignora o dedupe, então pode ser repetido. body: { publicadorId }
    dispararTesteDesignacoesPendentes: async (publicadorId) => {
        try {
            const response = await Api.post('/notificacoes/designacoes-pendentes/disparar-teste', { publicadorId });
            return response.data; // { mensagem, publicador, resultado }
        } catch (error) {
            console.error("Erro ao disparar teste de designações pendentes", error);
            throw error;
        }
    },

    // Lê a configuração da automação (ativo, horaDisparo, janelaDedupeHoras, ultimo*)
    getConfigDesignacoesPendentes: async () => {
        try {
            const response = await Api.get('/notificacoes/designacoes-pendentes/config');
            return response.data;
        } catch (error) {
            console.error("Erro ao obter config da automação", error);
            throw error;
        }
    },

    // Atualiza a automação. body: { ativo?, horaDisparo? (0-23), janelaDedupeHoras? (1-168) }
    atualizarConfigDesignacoesPendentes: async (dados) => {
        try {
            const response = await Api.put('/notificacoes/designacoes-pendentes/config', dados);
            return response.data;
        } catch (error) {
            console.error("Erro ao atualizar config da automação", error);
            throw error;
        }
    },

    // ===== Sino do cabeçalho — notificações do usuário logado =====

    // Lista as notificações do usuário (mesmo endpoint do app). Retorna lista achatada com { _id, titulo, mensagem, lida, createdAt, enviadoPorNome, designacaoId }
    listarMinhas: async () => {
        try {
            const response = await Api.get('/notificacoes/minhas', { params: { tipo: 'mensagem' } });
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error("Erro ao listar minhas notificações", error);
            return [];
        }
    },

    marcarComoLida: async (id) => {
        const response = await Api.post(`/notificacoes/${id}/marcar-lida`);
        return response.data;
    },

    marcarTodasComoLidas: async () => {
        const response = await Api.post('/notificacoes/marcar-todas-lidas', null, { params: { tipo: 'mensagem' } });
        return response.data;
    },

    // Apaga as notificações selecionadas — somem só para o usuário logado
    apagar: async (ids) => {
        const response = await Api.post('/notificacoes/apagar', { ids });
        return response.data; // { sucesso, apagadas }
    },

    // Apaga todas as notificações do usuário logado (mesmo tipo listado no sino)
    apagarTodas: async () => {
        const response = await Api.post('/notificacoes/apagar-todas', null, { params: { tipo: 'mensagem' } });
        return response.data; // { sucesso, apagadas }
    }
};

export default NotificacaoService;